import { useChangelogBuilderFormContext } from 'src/hooks/releases/useChangelogBuilderFormContext';

import { ShipPill, Subtitle } from './ChangelogBuilderContent.styles';

export const ChangelogBuilderContentSubtitle = () => {
  const { watch } = useChangelogBuilderFormContext();
  const subtitle = watch('subtitle');
  const shipIndex = subtitle.indexOf('ship');
  if (shipIndex >= 0) {
    // Replaces only the first "ship"
    return (
      <Subtitle>
        {subtitle.substring(0, shipIndex)}
        <ShipPill><span>ship</span></ShipPill>
        {subtitle.substring(shipIndex).replace('ship', '')}
      </Subtitle>
    );
  }
  return <Subtitle>{subtitle}</Subtitle>;
};
